import * as React from 'react';
import { Link as RouterLink, useLocation } from "react-router-dom";

import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import Typography from '@mui/material/Typography';

import { SPOC_breadcrumbNameMap } from "../DoctorMangement/constant"



export const RouterBreadcrumbs = () => {
  const location = useLocation();
  const path = location.pathname;
  const queryParams = new URLSearchParams(location.search);
  const myParam = queryParams.get('drId');

  const generateBreadcrumbs = () => {
    const breadcrumbs = [
      {
        to: `/SPOC/SPOCManagement`,
        label: 'SPOC List',
        underline: true,
        isActive: true
      },
      {
        label: myParam ? 'Edit SPOC ' : 'Add New SPOC',
        to: `${path}${myParam ? `?drId=${myParam}` : ''}`,
        underline: false,
        isActive: false

      }
    ];
    breadcrumbs.push({
      to: `${path}${myParam ? `` : ''}`,
      label: SPOC_breadcrumbNameMap[location.pathname],
      underline: true,
      isActive: false
    });
    return breadcrumbs;
  };

  return (
    <Stack spacing={2}>
      <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
        {generateBreadcrumbs().map(({ to, label, underline, isActive }, index) => (
          <>
            {isActive ?
              <Link
                underline={'none'}
                key={index}
                color={isActive ? '#0066DC' : 'inherit'}
                to={to}
                component={RouterLink}
              >
                {label}
              </Link>
              :
              <Typography key="3" sx={{ color: 'inherit' }}> {label}</Typography>
            }
          </>
        ))}
      </Breadcrumbs>
    </Stack>
  );
};
